export default __webpack_public_path__ + "static/Septic-Tank-Removal-292986f7389586b0a89aa8d7ee512a44.jpg";